import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// This app's locale folders are "en" and "rs" (rs = Serbia's country code,
// not the "sr" language code), so a real sr-RS/sr browser locale needs an
// explicit remap on top of the usual region-stripping.
const SUPPORTED_LANGUAGES = ["en", "rs"];
const LANGUAGE_ALIASES = { sr: "rs" };

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    detection: {
      convertDetectedLanguage: (lng) => {
        const base = lng.split("-")[0].toLowerCase();
        return LANGUAGE_ALIASES[base] || base;
      },
    },
    debug: false,

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    ns: [
      "common",
      "home",
      "navbar",
      "warehouse",
      "error",
      "items",
      "tags",
      "traffic",
      "clients",
      "units",
      "employees",
      "roles",
      "messages",
      "settings",
      "backend",
      "printer",
      "tutorial",
    ],
    defaultNS: "common",

    react: {
      useSuspense: false,
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
